import * as React from 'react';
import styled from 'styled-components';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import { BreadCrumbs } from '../molecules';
import GenerateReportForm, {
  Props as FormProps,
} from '../forms/GenerateReportForm';
import GenerateEmployeeReportForm from '../forms/GenerateEmployeeReportForm';

import useUserRole from '../hooks/useUserRole';

const ActionsPanelReports = ({
  onSubmit,
  isLoading,
  onExportToPDF,
  onChangeKey,
  isValidForExport,
  inspectionFormClick,
  setInspectionFormClick,
  setReportsSettings,
  forms,
  setForms,
}: any) => {
  const { isEmployee } = useUserRole();

  return (
    <Container>
      <Part>
        {isEmployee ? (
          <ReportingAnalyticsLink
            href="https://reports.elitepermits.com/login"
            target="_blank"
            rel="noopener noreferrer"
            title="Opens the Reporting & Analytics dashboard in a new tab"
          >
            Open Reporting &amp; Analytics Dashboard
            <OpenInNewIcon style={{ fontSize: 16 }} />
          </ReportingAnalyticsLink>
        ) : (
          <BreadCrumbs />
        )}
      </Part>
      <Part>
        {isEmployee ? (
          <GenerateEmployeeReportForm
            onSubmit={onSubmit}
            isLoading={isLoading}
            onExportToPDF={onExportToPDF}
            onChangeKey={onChangeKey}
            isValidForExport={isValidForExport}
            setInspectionFormClick={setInspectionFormClick}
            inspectionFormClick={inspectionFormClick}
            setReportsSettings={setReportsSettings}
            forms={forms}
            setForms={setForms}
          />
        ) : (
          <GenerateReportForm
            onSubmit={onSubmit}
            isLoading={isLoading}
            onExportToPDF={onExportToPDF}
          />
        )}
      </Part>
    </Container>
  );
};

const Container = styled.div`
  background: var(--secondary);
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: -24px;
  box-sizing: border-box;
  padding: 8px 40px;
  flex-wrap: wrap;
  gap: 12px;

  @media only screen and (max-width: 840px) {
    margin-left: 0;
    padding: 8px 14px;
  }

  @media only screen and (max-width: 540px) {
    padding: 8px 10px;
    gap: 8px;
  }
`;

const ReportingAnalyticsLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 14px;
  border: none;
  border-radius: 5px;
  background: var(--primary-600);
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  white-space: nowrap;
  color: var(--neutral-0);
  text-decoration: none;
  cursor: pointer;
  box-shadow: var(--shadow-xs);
  transition: background-color 0.15s ease;

  &:hover {
    background: var(--primary-700);
    color: var(--neutral-0);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }

  svg {
    flex-shrink: 0;
  }
`;

const Part = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;

  > * {
    margin: 0;
  }

  .MuiTextField-root,
  .MuiInputBase-root {
    border-radius: 5px;
  }

  .MuiButton-root,
  .MuiInputBase-root {
    height: 30px;
  }

  @media only screen and (max-width: 540px) {
    width: 100%;
    gap: 8px;
  }
`;

type Props = Pick<
  FormProps,
  'onSubmit' | 'isLoading' | 'onExportToPDF'
>;

export default ActionsPanelReports;
